// eslint-disable-next-line import/prefer-default-export
export enum PORTAL_TYPE {
  ERDE = 'ERDE',
  ER1 = 'ER1',
  UMER = 'UMER',
  FMER = 'FMER',
  EBUSER = 'EBUSER',
  EBCLIENT = 'EBCLIENT'
}

export enum ACTIVE_ICON {
  NONE = 'NONE',
  ALL = 'ALL',
  ERDE = 'ERDE',
  ER1 = 'ER1',
  UMER = 'UMER',
  FMER = 'FMER',
  EBUSER = 'EBUSER'
}

export type HeaderType = 'support' | 'partner' | 'product';
